// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const OutOfStock: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M27.8 5.2c-3-3-7-4.7-11.3-4.7-4.3 0-8.3 1.7-11.3 4.7S.5 12.2.5 16.5c0 4.3 1.7 8.3 4.7 11.3 3.1 3.1 7.2 4.7 11.3 4.7s8.2-1.6 11.3-4.7c3-3 4.7-7 4.7-11.3 0-4.3-1.7-8.3-4.7-11.3zm-2.1 2.1c2.5 2.5 3.8 5.7 3.8 9.2 0 3-1 5.8-2.8 8L8.5 6.3c2.3-1.8 5.1-2.8 8-2.8 3.5 0 6.7 1.4 9.2 3.8zM7.3 25.7c-2.5-2.5-3.8-5.7-3.8-9.2 0-3 1-5.8 2.8-8l18.2 18.2c-2.3 1.8-5.1 2.8-8 2.8-3.5 0-6.7-1.4-9.2-3.8z"/></svg>;
};

export default React.memo(OutOfStock);
